import { FiltersActionTypes } from './filtersTypes';
const initialState = {
    list: []
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FiltersActionTypes.FETCH_FILTERS_SUCCESS:
            return Object.assign(Object.assign({}, state), { list: action.payload });
        default:
            return state;
    }
};
export { reducer as filtersReducer };
